/**
 * Ajout au panier en AJAX — partagé par la vitrine produit de l'accueil et le
 * bloc produit du catalogue.
 *
 * Le thème n'avait aucun panier asynchrone : le panneau de l'en-tête est rendu
 * côté serveur et tous les chemins d'achat passaient par un rechargement.
 * Ce module ajoute la variante, redemande l'en-tête à l'API de rendu de
 * sections pour que le compteur et le contenu du panneau soient réels plutôt
 * que devinés côté client, puis ouvre le panneau.
 *
 * Expose :
 *   window.yumbeiCart.add(variantId, quantity) -> Promise
 *
 * Câblage déclaratif, sans écrire de JS dans les sections :
 *   <button data-cart-add="{{ variant.id }}" data-cart-qty="1">
 */
(function () {
  // Shopify préfixe les routes avec la locale (/fr/, /en/) ; window.Shopify.routes
  // porte la bonne racine. Le repli couvre le cas où l'objet n'est pas encore là.
  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /**
   * La fenetre du panier (snippets/cart-popup.liquid), remplie du contenu du
   * volet de l'en-tete.
   *
   * Rien n'est reconstruit ici : on recopie le contenu du volet, qui vient
   * d'etre rendu par le serveur (voir refreshHeader). Lignes, sous-total,
   * barre de livraison et boutons sont donc ecrits une seule fois, en Liquid.
   *
   * @param {boolean} [silencieux] - true pour ne remplir que si la fenetre est
   *   deja ouverte. C'est ce que fait un changement de quantite : il doit
   *   rafraichir ce qu'on regarde, jamais ouvrir la fenetre de sa propre
   *   initiative.
   * @returns {boolean} true si la fenetre est a l'ecran a la sortie.
   */
  function popupPanier(silencieux) {
    var popup = document.querySelector('[data-cart-popup]');
    var corps = popup && popup.querySelector('[data-cart-popup-body]');
    var panel = document.querySelector('[data-cart-panel]');
    if (!popup || !corps || !panel) return false;
    if (silencieux && !popup.open) return false;

    // innerHTML et non un clone du volet : c'est son CONTENU qu'on veut, pas
    // sa boite — celle-ci porte le positionnement absolu du survol, qui n'a
    // aucun sens dans une fenetre modale.
    corps.innerHTML = panel.innerHTML;

    if (!popup.open) {
      // showModal et non show : c'est lui qui pose le fond, retient le focus
      // et branche la touche Echap.
      if (typeof popup.showModal === 'function') popup.showModal();
      else popup.setAttribute('open', '');
    }
    return true;
  }

  /**
   * Accuse reception d'un ajout par le moyen disponible, et dit si quelque
   * chose a paru a l'ecran.
   *
   * Trois moyens, un seul a la fois — deux ensemble diraient deux fois la meme
   * chose, l'une par-dessus l'autre :
   *
   *   · au-dessus de 1410px, le volet du panier de l'en-tete, que `add` vient
   *     d'ouvrir. Il est la reponse, il n'y a rien a ajouter ;
   *   · en dessous, la fenetre. Le volet y est a `display: none` — au doigt il
   *     n'y a pas de survol pour l'atteindre, et sous 640 les trois icones se
   *     replient elles-memes derriere un bouton. On ajoutait donc au panier
   *     sans rien voir, et c'est ce qui a ete signale le 10/09 ;
   *   · a defaut, la bulle de confirmation (voir confirmerAjout).
   *
   * Le VOLET decide, et non une largeur recopiee ici. Il est a `display: none`
   * exactement la ou il n'est pas atteignable : lire son etat calcule, c'est
   * suivre la feuille de style sans avoir a redire son seuil dans le script —
   * un endroit de moins a changer le jour ou il bouge.
   *
   * @returns {boolean} true si le volet ou la fenetre a paru.
   */
  function accuserReception() {
    var panel = document.querySelector('[data-cart-panel]');
    if (panel && window.getComputedStyle(panel).display !== 'none') return true;
    return popupPanier();
  }

  function fermerPopupPanier() {
    var popup = document.querySelector('[data-cart-popup]');
    if (!popup || !popup.open) return;
    if (typeof popup.close === 'function') popup.close();
    else popup.removeAttribute('open');
  }

  function openCartPanel() {
    var panel = document.querySelector('[data-cart-panel]');
    if (!panel) return;
    panel.classList.add('is-open');

    // Le panneau s'ouvre normalement au survol ; ouvert par script il doit se
    // refermer autrement, sinon il resterait posé sur la page.
    function close(event) {
      var flyout = panel.closest('.site-header__flyout');
      if (event && flyout && flyout.contains(event.target)) return;
      panel.classList.remove('is-open');
      document.removeEventListener('click', close);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(event) {
      if (event.key === 'Escape') close();
    }
    // Différé d'un tick : sans cela le clic qui a déclenché l'ajout referme
    // le panneau dans la foulée.
    setTimeout(function () {
      document.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
    }, 0);
  }

  /**
   * L'enveloppe de la section d'en-tête, retrouvée par son contenu.
   *
   * Surtout PAS par un identifiant écrit en dur. L'en-tête vit dans un groupe
   * de sections (sections/header-group.json), et Shopify donne alors à la
   * section un identifiant dynamique de la forme « sections--1234__header ».
   * L'enveloppe s'appelle donc « shopify-section-sections--1234__header », et
   * le nombre change d'une boutique à l'autre.
   *
   * C'est ce qui cassait le rafraîchissement jusqu'au 27/08, et deux fois
   * plutôt qu'une : la requête demandait « ?sections=header », un identifiant
   * qui n'existe pas, et la réponse était ensuite cherchée sous
   * « #shopify-section-header », qui n'existe pas davantage. Les deux échecs
   * étaient muets — le panneau s'ouvrait quand même, avec son contenu périmé.
   *
   * data-site-header est posé sur le <header> lui-même : on remonte de là vers
   * l'enveloppe, quel que soit son nom.
   */
  function headerSection() {
    var header = document.querySelector('[data-site-header]');
    return header && header.closest('[id^="shopify-section-"]');
  }

  /**
   * Remplace l'en-tête par sa version fraîchement rendue. L'API de rendu de
   * sections renvoie le HTML du serveur, donc le compteur et les lignes du
   * panier sont exacts — reconstruire le panneau à la main aurait dupliqué la
   * logique de prix et de quantité déjà écrite en Liquid.
   */
  function refreshHeader() {
    var current = headerSection();
    if (!current) return Promise.resolve();

    var sectionId = current.id.replace(/^shopify-section-/, '');

    return fetch(root() + '?sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data[sectionId];
        if (!html) return;

        var holder = document.createElement('div');
        holder.innerHTML = html;

        // Même repère à l'arrivée qu'au départ : le fragment renvoyé porte la
        // même enveloppe, donc le même identifiant dynamique.
        var freshHeader = holder.querySelector('[data-site-header]');
        var fresh = (freshHeader && freshHeader.closest('[id^="shopify-section-"]'))
          || holder.firstElementChild;
        if (!fresh) return;

        current.replaceWith(fresh);
        // L'en-tête réécrit a perdu ses écouteurs : la section les repose sur
        // cet évènement, comme le fait l'éditeur de thème.
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      });
  }

  /**
   * Pose l'attribut de panier qui marque la commande comme précommande dans
   * l'admin (note_attributes) — sans lui, rien ne distingue une précommande
   * payée d'une commande normale une fois passée : les deux sont payées et
   * non exécutées de la même façon, voir la remarque de settings_schema.json.
   *
   * Posé une seule fois par chargement de page : l'attribut reste sur le
   * panier tant qu'on ne le change pas, donc les ajouts suivants n'ont rien à
   * refaire. `precommandeEnEchec` permet de retenter au prochain ajout si la
   * requête a échoué, plutôt que d'abandonner pour le reste de la session.
   */
  var precommandePosee = false;

  function marquerPrecommande() {
    if (!document.body.dataset.preorder || precommandePosee) return Promise.resolve();

    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Précommande': 'Oui' } })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update ' + res.status);
        precommandePosee = true;
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.warn('[yumbei] attribut précommande non posé', err);
      });
  }

  function add(variantId, quantity) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (payload) {
        return marquerPrecommande().then(function () {
          return refreshHeader().then(function () {
            openCartPanel();
            return payload;
          });
        });
      });
  }

  /**
   * Règle la quantité d'une ligne du panier, puis redemande l'en-tête au
   * serveur — même trajet que `add`, et pour la même raison : le panneau est
   * rendu en Liquid, et recalculer un sous-total ou une barre de livraison
   * côté client aurait dupliqué ce que la section sait déjà faire.
   *
   * `line` est le rang de l'article dans le panier, à partir de 1, tel que
   * l'écrit le Liquid au rendu. Une quantité de 0 retire la ligne : c'est le
   * comportement de /cart/change, et celui de la page panier.
   */
  function change(line, quantity) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (payload) {
        return refreshHeader().then(function () { return payload; });
      });
  }

  // ---- La confirmation d'ajout, au doigt ----
  //
  // Sur grand écran, un ajout ouvre le panneau du panier dans l'en-tête et
  // cela suffit à dire que le geste a porté. Au doigt, le panneau est replié
  // derrière le bouton à trois points : rien ne bougeait à l'écran, on
  // cliquait dans le vide (signalé le 09/09).
  //
  // Depuis le 10/09, c'est la FENÊTRE du panier qui répond partout où le volet
  // ne s'ouvre pas (voir popupPanier). La bulle ne sert donc plus que de filet,
  // pour le cas où cette fenêtre n'a pas pu s'ouvrir — un <dialog> absent du
  // balisage, ou un navigateur qui n'en a pas. Les deux ensemble diraient deux
  // fois la même chose, l'une par-dessus l'autre.
  //
  // Le seuil de largeur a disparu avec cette bascule : ce n'est plus l'écran
  // qui décide, c'est ce qui a pu paraître.
  var minuteurBulle = null;

  function confirmerAjout(fenetreOuverte) {
    if (fenetreOuverte) return;

    var bulle = document.querySelector('[data-cart-toast]');
    if (!bulle) return;

    // Le libellé est ÉCRIT ici, et non laissé dans l'élément au chargement :
    // c'est le changement de contenu qui fait annoncer un role="status" par un
    // lecteur d'écran. Rempli d'avance, il aurait été lu une fois, à
    // l'ouverture de la page, et plus jamais.
    var texte = bulle.dataset.label;
    if (!texte) return; // pas de libellé traduit : mieux vaut rien que l'anglais

    // Vidé puis réécrit : deux ajouts de suite doivent être annoncés deux
    // fois, or un texte identique réécrit tel quel ne déclenche rien.
    bulle.textContent = '';
    // Un tick, le temps que le vidage soit vu.
    window.setTimeout(function () {
      bulle.textContent = texte;
      bulle.classList.add('is-on');
    }, 0);

    window.clearTimeout(minuteurBulle);
    minuteurBulle = window.setTimeout(function () {
      bulle.classList.remove('is-on');
      // Vidée seulement une fois le fondu terminé : `:empty` la retire de la
      // mise en page, et la retirer d'emblée escamoterait la sortie.
      window.setTimeout(function () {
        if (!bulle.classList.contains('is-on')) bulle.textContent = '';
      }, 400);
    }, 2600);
  }

  window.yumbeiCart = {
    add: add,
    confirmerAjout: confirmerAjout,
    change: change,
    refreshHeader: refreshHeader,
    openCartPanel: openCartPanel,
    popupPanier: popupPanier,
    accuserReception: accuserReception,
    fermerPopupPanier: fermerPopupPanier
  };

  // ---- Fermer la fenêtre du panier ----
  //
  // Échap et le focus retenu viennent du <dialog> lui-même. Restent la croix
  // et le clic sur le fond : celui-ci arrive sur le <dialog>, pas sur la boîte
  // — le fond N'EST PAS un élément, c'est le pseudo-élément ::backdrop, et un
  // clic dessus a pour cible le dialogue. Un clic dans la boîte a pour cible la
  // boîte ou l'un de ses enfants, d'où le test.
  //
  // Un lien du panier — « voir le panier », « commander » — n'a rien à fermer :
  // il quitte la page.
  document.addEventListener('click', function (event) {
    var popup = document.querySelector('[data-cart-popup]');
    if (!popup || !popup.open) return;

    if (event.target.closest('[data-cart-popup-close]')) {
      fermerPopupPanier();
      return;
    }
    if (event.target === popup) fermerPopupPanier();
  });

  // ---- Pas de quantité, dans l'aperçu du panier ----
  //
  // Un seul verrou pour tout le panneau, et non un par bouton : l'en-tête est
  // réécrit à chaque réponse, donc un drapeau posé sur l'élément cliqué
  // disparaîtrait avec lui. Deux clics rapides sur « + » partiraient alors
  // avec la même quantité de départ, et le second annulerait le premier.
  var changing = false;

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-cart-change]');
    if (!step) return;

    // Le href reste un vrai lien vers /cart/change : sans JavaScript il agit
    // seul, au prix d'un rechargement. On ne le court-circuite qu'ici.
    event.preventDefault();
    if (changing) return;
    changing = true;
    step.setAttribute('aria-busy', 'true');

    var line = step.dataset.cartChange;
    var direction = step.dataset.cartStep;

    change(line, step.dataset.cartTo)
      .then(function () {
        // Le panneau s'ouvre au survol ; réécrit sous le curseur, il a besoin
        // qu'on le retienne ouvert, sinon il disparaît au moment même où l'on
        // regarde le chiffre changer.
        openCartPanel();

        // La fenêtre, si elle est ouverte, regarde le même panier : elle doit
        // suivre le chiffre qui vient de changer. En mode silencieux — elle ne
        // s'ouvre pas d'elle-même sur un « + », seulement sur un ajout.
        popupPanier(true);

        // Le bouton cliqué n'existe plus. On rend le clavier à son équivalent
        // sur la ligne fraîche — et à défaut (la ligne vient d'être retirée)
        // au premier pas du panneau, plutôt que de laisser le focus retomber
        // sur <body> et la navigation repartir du haut de la page.
        //
        // Cherché DANS la fenêtre quand c'est elle qu'on regarde : les deux
        // portent désormais les mêmes repères, et l'en-tête vient en premier
        // dans le document. Le focus serait donc allé à son bouton à lui, qui
        // est masqué à toutes les largeurs où la fenêtre s'ouvre — c'est-à-dire
        // nulle part, et la navigation serait repartie du haut de la page.
        var popup = document.querySelector('[data-cart-popup]');
        var portee = popup && popup.open ? popup : document;
        var fresh = portee.querySelector(
          '[data-cart-change="' + line + '"][data-cart-step="' + direction + '"]'
        ) || portee.querySelector('[data-cart-change]');
        if (fresh) fresh.focus();
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.warn('[yumbei] quantité non modifiée', err);
      })
      .then(function () {
        changing = false;
        // Sans effet quand la requête a abouti — le bouton a été remplacé avec
        // l'en-tête — mais indispensable quand elle a échoué : sinon la ligne
        // reste annoncée occupée jusqu'au prochain rechargement.
        step.removeAttribute('aria-busy');
      });
  });

  // ---- Câblage déclaratif ----
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-add]');
    if (!trigger) return;

    var variantId = trigger.dataset.cartAdd;
    if (!variantId) return; // pas de variante connue : on laisse le lien agir

    event.preventDefault();
    if (trigger.dataset.cartBusy) return;
    trigger.dataset.cartBusy = '1';
    trigger.setAttribute('aria-busy', 'true');

    add(variantId, parseInt(trigger.dataset.cartQty, 10) || 1)
      .then(function () {
        confirmerAjout(accuserReception());
      })
      .catch(function (err) {
        // Rupture de stock, variante retirée : l'utilisateur doit le voir
        // plutôt que de cliquer dans le vide.
        var message = (err && (err.description || err.message)) || '';
        if (message) trigger.setAttribute('data-cart-error', message);
        // eslint-disable-next-line no-console
        console.warn('[yumbei] ajout au panier refusé', err);
      })
      .then(function () {
        delete trigger.dataset.cartBusy;
        trigger.removeAttribute('aria-busy');
      });
  });
})();
